<template>
	<el-container id="guide_text">
        <div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<guidetextassembly :news_id="news_id"></guidetextassembly>
	</el-container>
</template>

<script>
import guidetextassembly from '@/components/dyy_assembly/guideTextAssembly.vue'
export default {
	name: 'guide'
	,data () {
		return {
            test_tit:'详情',
            location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name:  this.$store.state.defaultIndex,
                query:{page: this.$store.state.defaultIndex}
			},{
				title:"报考指南",
				router:"/web/guide/",
				name: 'guide',
				query:{page:'guide'}
			}],
			news_id:this.$route.query.id
		}
	}
	,mounted:function(option){
		if(this.$route.query.page=="guide"){
			this.hed = "报考指南"
			this.location[1] = {
				title:"报考指南",
				router:"/web/guide/",
				name: 'guide',
				query:{page:'guide'}
			}
		}else if(this.$route.query.page=="problem"){
			this.hed = "常见问题"
			this.location[1] = {
				title:"常见问题",
				router:"/web/problem/",
				name: 'problem',
				query:{page:'problem'}
			}
		}else if(this.$route.query.page=="announcement_list"){
			this.hed = "通知公告"
			this.location[1] = {
				title:"通知公告",
				router:"/web/announcement_list/",
				name: 'announcement_list',
				query:{page:'announcement_list'}
			}
		}
		this.$forceUpdate();
		// console.log(this.hed);
		// console.log(this.location);
		
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,components:{
        guidetextassembly
    }
	,methods:{
        //点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/info/guide_text.vue